import { createFileRoute, useSearch } from "@tanstack/react-router";
import { hydrate, useQueryClient, useQuery, DehydratedState, dehydrate } from "@tanstack/react-query";
import { businessTypeQueryOptions } from "@/server/business-directory";
import { TypeForm } from "../-components/type-form";
import { TypeReadable } from "@/lib/mma/types.gen";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_dashboard/business-directory/types")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    const id = search.id as number | string | undefined;
    return { id };
  },
  loaderDeps: ({ search }) => {
    return { id: search.id };
  },
  loader: async ({ context, deps }) => {
    const { id } = deps;

    if (id === "new") {
      return {
        crumb: "New Type",
      };
    } else if (id) {
      try {
        const queryOptions = businessTypeQueryOptions(id as number);
        await context.queryClient.prefetchQuery(queryOptions);
        const typeData = context.queryClient.getQueryData(queryOptions.queryKey) as TypeReadable | undefined;
        return {
          crumb: typeData?.name || `Type ${id}`,
          dehydratedState: dehydrate(context.queryClient) as any,
        };
      } catch (error) {
        return {
          crumb: `Type ${id}`,
        };
      }
    }

    return {
      crumb: "Types",
    };
  },
});

function RouteComponent() {
  const { dehydratedState } = Route.useLoaderData() as { dehydratedState: DehydratedState };
  const queryClient = useQueryClient();
  hydrate(queryClient, dehydratedState);
  const search = useSearch({ from: "/_dashboard/business-directory/types" });
  const isNew = search.id === "new";

  const typeQuery = useQuery(businessTypeQueryOptions(typeof search.id === "number" ? search.id : 0));
  const type = typeQuery.data;

  if (!type?.id && !isNew) {
    return (
      <Card>
        <CardContent>
          <p className="text-md pb-20 pt-15 text-center">Please select a type to view its details.</p>
        </CardContent>
      </Card>
    );
  }
  return <TypeForm type={type as TypeReadable} isEdit={!isNew} />;
}
